import React, { useEffect, useState, ReactNode, PropsWithChildren } from "react";
import classnames from "classnames";

import { Drawer, IconButton, List } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import {
  ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";

import useLayoutStyles from './sidebar.style';

import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../../context";

export interface SidebarProps extends PropsWithChildren<any> {
  listItems: ReactNode[];
}

function Sidebar(props: SidebarProps) {
  const { listItems } = props;

  const classes = useLayoutStyles();
  const theme = useTheme() as any;

  // global
  const { isSidebarOpened } = useLayoutState();
  const layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;
  
    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classnames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classnames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon />
        </IconButton>
      </div>
      <List>
        {listItems}
      </List>
    </Drawer>
  );
}

export { Sidebar };